import React from 'react';
import { Link } from 'react-router-dom';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';

class AboutUsPage extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <div className="sub-banner">
          <div className="overlay">
            <div className="container">
              <div className="breadcrumb-area">
                <div className="top">
                  <h1>Acerca de</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="typography-page">
          <div className="container">
            <div className="row mrg-btm-40">
              <div className="col-md-12">
                <h4 className="headline">¿Qué es Escena?</h4>
                <p>
                  Escena es la primera plataforma digital internacional que
                  promociona producciones clásicas ya estrenadas fomentando la
                  circulación entre teatros y generando un mercado secundario.
                </p>

                <p>
                  Con una red de teatros de más de 20 integrantes de todo el
                  mundo respaldando la calidad y número de producciones
                  disponibles, la visión de Escena es entregar información para
                  facilitar la circulación de obras y así generar más contenido
                  clásico en los teatros de la región Latinoamérica.
                </p>
              </div>
            </div>
            <div className="row mrg-btm-40">
              <div className="col-md-12">
                <h4 className="headline">¿Cómo funciona?</h4>
                <p>
                  Escena muestra y conecta producciones clásicas de casas de
                  ópera y compañías líricas de renombre mundial con
                  programadores de teatros en busca de repertorio clásico para
                  sus temporadas.
                </p>

                <ol>
                  <li>
                    Si quieres arrendar o vender una producción que tienes en
                    bodega, regístrate aquí y oferta producciones completas o
                    elementos sueltos que estén en buenas condiciones.
                  </li>
                  <li>
                    Si buscas producciones de ópera o ballet para tu temporada
                    regístrate aquí para conectarte con teatros y compañías
                    productoras, para recibir notificaciones e información
                    complementaria que te facilitar el proceso de programación.
                  </li>
                </ol>

                <p>
                  <strong>
                    Algunos de los beneficios de suscribirse a Escena son:
                  </strong>
                </p>
                <ol>
                  <li>
                    Acceder a información de obras disponibles en todo el mundo.
                  </li>
                  <li>
                    Podrás generar un ingreso extra a través de la
                    comercialización de producciones ya estrenadas.
                  </li>
                  <li>Conectar con teatros de tu región y del mundo.</li>
                </ol>
              </div>
            </div>

            <div className="section-1 looking-for">
              <div className="container">
                <div className="main-title">
                  <h1>Suscríbete</h1>
                  <div className="border">
                    <div className="border-inner" />
                  </div>
                  <Link to="/login" className="btn button-md button-theme mb-40">Registrate aquí</Link>
                </div>

                <Link to="/plans" className="btn button-md button-theme">Ver membresías</Link>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default AboutUsPage;



// WEBPACK FOOTER //
// ./src/containers/General/AboutUsPage/index.js